// extracted by mini-css-extract-plugin
module.exports = {"fullWidth":"styles_fullWidth__5m2Jy"};